<template>
  <div v-if="keywordList">
    <b-row class="mb-1" v-if="showImportKeyword">
      <b-col>
        <span class="keyword-tag">Keyword Tag</span>
      </b-col>
      <b-col class="d-flex justify-content-end">
        <u class="pointer" @click="$refs.modalImportKeyword.show()">Import</u>
      </b-col>
    </b-row>

    <div class="" v-if="!readOnly">
      <b-input-group
        :class="[
          'panel-input-keyword',
          { 'border-radius-bottom': keywordList.length == 0 },
        ]"
      >
        <b-form-input
          type="text"
          class="input-custom"
          @keyup.13="onAddKeyword"
          @paste="onPasteKeyword"
          v-if="refreshAfterPaste"
          v-model="keyword"
        ></b-form-input>
        <b-input-group-append>
          <b-button
            class="btn btn-add-keyword"
            @click="onAddKeyword"
            :disabled="!keyword"
          >
            <font-awesome-icon class="" size="sm" icon="plus" />
          </b-button>
        </b-input-group-append>
      </b-input-group>
      <div class="mt-1" v-if="v && v.$error">
        <span class="text-error">
          กรุณากรอกคีย์เวิร์ดอย่างน้อย 1 คีย์เวิร์ด
        </span>
      </div>
    </div>

    <div
      class="px-3 py-2 mb-2 keyword-card"
      v-if="keywordList.length > 0"
      :style="containerCustomCss ? containerCustomCss : null"
    >
      <div class="d-flex flex-wrap" v-if="isShowAllKeyword">
        <div
          v-for="(keyword, kindex) in keywordList"
          :key="kindex"
          class="d-flex keyword-box p-1 m-1"
          :style="keyWordCustomCss ? keyWordCustomCss : null"
        >
          <div class="m-auto text-keyword px-2">
            {{ keyword }}
          </div>
          <div class="ml-3" v-if="!readOnly">
            <font-awesome-icon
              class="my-auto"
              icon="times"
              @click="onDeleteKeyword(keyword)"
            />
          </div>
        </div>
      </div>
      <div v-else class="d-flex flex-wrap">
        <div
          v-for="(keyword, kindex) in keywordList.slice(0, showKeywordLength)"
          :key="kindex"
          class="d-flex keyword-box p-1 m-1"
          :style="keyWordCustomCss ? keyWordCustomCss : null"
        >
          <div class="m-auto text-keyword px-2">
            {{ keyword }}
          </div>
          <div class="ml-2 mr-1" v-if="!readOnly">
            <font-awesome-icon
              class="my-auto"
              icon="times"
              @click="onDeleteKeyword(keyword)"
            />
          </div>
        </div>
      </div>
      <div
        class="ml-1 my-auto text-main-color w-100 text-right"
        @click="$emit('setShowAllKeyword')"
        v-if="keywordList.length > showKeywordLength && !isShowAllKeyword"
      >
        See more ({{ keywordList.length }})
      </div>
    </div>

    <ModalImportKeyword
      v-if="refreshKeywordModal"
      ref="modalImportKeyword"
      :keywordList="keywordList"
      v-on:onImportKeyword="onImportKeyword"
    />
  </div>
</template>

<script>
import ModalImportKeyword from "@/views/pages/flow-builder/components/modal/ModalImportKeyword";
export default {
  components: {
    ModalImportKeyword,
  },
  props: {
    keywordList: {
      required: false,
      type: Array,
    },
    readOnly: {
      required: false,
      type: Boolean,
      default: false,
    },
    showAllList: {
      required: false,
      type: Boolean,
      default: true,
    },
    keyWordCustomCss: {
      required: false,
      type: Object,
    },
    containerCustomCss: {
      required: false,
      type: Object,
    },
    v: {
      required: false,
      type: Object,
    },
    showKeywordLength: {
      required: false,
      type: Number,
    },
    showImportKeyword: {
      required: false,
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      keyword: "",
      isShowAll: false,
      refreshAfterPaste: true,
      refreshKeywordModal: true,
    };
  },
  computed: {
    isShowAllKeyword: {
      get() {
        return this.showAllList;
      },
      set(newValue) {
        return newValue;
      },
    },
  },
  methods: {
    onImportKeyword(keywordList) {
      this.$emit("onImportKeyword", keywordList);
    },
    onPasteKeyword(event) {
      // this.keyword = event.clipboardData.getData("text");
      var keywordList = [];
      if (event.clipboardData.getData("text").includes("\n")) {
        keywordList = event.clipboardData.getData("text").split("\n");
        keywordList.forEach((element) => {
          this.keywordList.push(element);
        });
        this.keyword = "";
        this.refreshAfterPaste = false;
        this.$nextTick(() => {
          this.refreshAfterPaste = true;
        });
      }
    },
    onAddKeyword() {
      if (this.keyword) {
        this.keywordList.push(this.keyword.trim());
        this.keyword = "";
      }
    },
    onDeleteKeyword(keyword) {
      const index = this.keywordList.indexOf(keyword);
      if (index > -1) {
        if (this.keywordList) {
          this.keywordList.splice(index, 1);
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.panel-input-keyword {
  background-color: #fff;
  border: 1px solid #bcbcbc !important;
  color: #4a4a4a;
  width: 100%;
  margin-right: 10px;
  color: #092d53 !important;
  border-radius: 6px 6px 0px 0px;
}
.border-radius-bottom {
  border-radius: 6px;
}
.border-radius-bottom > .input-custom {
  border-radius: 6px;
}
.keyword-card {
  border-left: 1px solid #bcbcbc;
  border-right: 1px solid #bcbcbc;
  border-bottom: 1px solid #bcbcbc;
  height: 125px;
  overflow: auto;
  border-radius: 0px 0px 6px 6px;
}
.input-custom {
  color: #16274a;
  background-color: white;
  border: 0;
  border-radius: 6px 6px 0px 0px;
  padding: 5px 10px;
}
.w-25 {
  width: 25%;
}
.keyword-box {
  background-color: #e2dff3;
  color: #7b7b7b !important;
  font-size: 14px;
  white-space: break-spaces;
  font-weight: 400 !important;
  border-radius: 25px;
}
.keyword-div {
  max-height: 150px;
  overflow-y: auto;
}
.text-keyword {
  word-break: break-word;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.keyword-contain {
  color: white;
}
.bg-grey {
  background-color: #00000029;
}
.title-keyword {
  font-size: 16px;
}
.btn-add-keyword {
  margin: 0.175rem;
  padding: 0.25rem 0.75rem 0.25rem 0.75rem;
  background-color: #b41bb4;
  border-color: #b41bb4;
  color: white;
  border-radius: 6px !important;
}

.text-error {
  color: #ff0000;
  font-size: 14px;
}
.text-main-color {
  color: #40a9d1;
}
.main-color:disabled {
  opacity: 0.8;
  background-color: #16274a;
  color: white;
}
.text-black {
  color: black;
}
::v-deep .card {
  margin-bottom: 10px;
}
::v-deep .div-input {
  margin-bottom: 10px;
}
.w-cal-32xem {
  width: calc(100% - 2rem);
}

@media (max-width: 1200px) {
  .panel-input-keyword {
    max-width: 100%;
  }
}
</style>
